import React from 'react';
import classNames from 'classnames';

import css from './IconCustomDate.module.css';

/**
 * Map pin icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @returns {JSX.Element} SVG icon
 */
const IconCustomDate = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);
  return (
    <svg
    className={classes}
    width="22" height="22" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 0C8.60621 0 9.18759 0.240816 9.61624 0.66947C10.0449 1.09812 10.2857 1.6795 10.2857 2.28571V4.57143H21.7143V2.28571C21.7143 1.6795 21.9551 1.09812 22.3838 0.66947C22.8124 0.240816 23.3938 0 24 0C24.6062 0 25.1876 0.240816 25.6162 0.66947C26.0449 1.09812 26.2857 1.6795 26.2857 2.28571V4.57143H28.5714C29.4807 4.57143 30.3528 4.93265 30.9958 5.57563C31.6388 6.21862 32 7.09069 32 8V10.2857H0V8C0 7.09069 0.361223 6.21862 1.00421 5.57563C1.64719 4.93265 2.51926 4.57143 3.42857 4.57143H5.71429V2.28571C5.71429 1.6795 5.9551 1.09812 6.38376 0.66947C6.81241 0.240816 7.39379 0 8 0Z"
        fill="#13472E"
      />
      <path
        d="M0 10.2858H32V28.5715C32 29.4808 31.6388 30.3529 30.9958 30.9958C30.3528 31.6388 29.4807 32.0001 28.5714 32.0001H3.42857C2.51926 32.0001 1.64719 31.6388 1.00421 30.9958C0.361223 30.3529 0 29.4808 0 28.5715L0 10.2858Z"
        fill="#ACCABB"
      />
    </svg>
  );
};

export default IconCustomDate;
